import React from 'react';
import PropTypes from 'prop-types';
import { createPopup, closePopup } from '../../../services/popupService';
import { logout } from '../../../api/user';
import environment from '../../../environment';
import cloneDeep from 'lodash/cloneDeep';
import { calculateRemainingTime } from '../../../util/util';
import { CommonBlueButton } from '../../common/buttonsComponents';
import { ContentWrapper, Header, PopupContent, PopupImage, PopupTextBlock } from '../Popups.styles';

export class ErrorPopup extends React.Component {
  static propTypes = {
    message: PropTypes.string.isRequired,
    header: PropTypes.string,
    showLogout: PropTypes.bool,
  };

  static defaultProps = {
    showLogout: false,
  };

  state = {
    expirationTime: cloneDeep(this.props.expirationTime),
    modifiedHeader: cloneDeep(this.props.header),
  };

  componentDidMount() {
    const { expirationTime } = this.state;

    if (expirationTime) {
      this.setMessageInterval();
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.handleCloseClick();
  }

  setMessageInterval() {
    this.interval = setInterval(() => {
      const { minutes, seconds, rawSeconds, rawMinutes } = calculateRemainingTime(this.state.expirationTime);
      let { modifiedHeader } = this.state;

      const timeString = `${minutes}:${seconds}`;

      if (rawSeconds <= 0 && rawMinutes <= 0) {
        clearInterval(this.interval);
        modifiedHeader = modifiedHeader.replace(/([0-9])+:([0-9])+/g, '00:00');
      } else {
        modifiedHeader = modifiedHeader.replace(/([0-9])+:([0-9])+/g, timeString);
      }

      this.setState({ modifiedHeader });
    }, 1000);
  }

  getButtonText() {
    return this.props.showLogout ? 'Logout' : 'Ok';
  }

  getHeaderText() {
    const { modifiedHeader } = this.state;
    const { expirationTime, header } = this.props;
    const headerText = header || 'Something went wrong!';

    return expirationTime ? modifiedHeader : headerText;
  }

  async handleCloseClick() {
    closePopup();
    if (this.props.showLogout) {
      await logout();
    }
  }

  renderMessage() {
    return <PopupTextBlock>{this.props.message}</PopupTextBlock>;
  }

  render() {
    return (
      <ContentWrapper>
        <PopupContent>
          <PopupImage src="/images/x-green.svg" alt="x-green" />
          <Header>{this.getHeaderText()}</Header>
          {this.renderMessage()}
          <CommonBlueButton width={'100%'} onClick={() => this.handleCloseClick()}>
            {this.getButtonText()}
          </CommonBlueButton>
        </PopupContent>
      </ContentWrapper>
    );
  }
}

const showErrorPopup = (message, header, showLogout, expirationTime) => {
  if (environment.app.disableErrorPopup !== true) {
    return createPopup({
      type: 'ErrorPopup',
      title: null,
      content: <ErrorPopup message={message} header={header} showLogout={showLogout} expirationTime={expirationTime} />,
      noOverlay: false,
    });
  }

  return null;
};

export { showErrorPopup };
